export default function () {
  let today = new Date()

  let days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  let day = today.getDay()
  let dd = today.getDate()
  let mm = today.getMonth() + 1
  let yyyy = today.getFullYear()

  let HH = today.getHours()
  let MM = today.getMinutes()

  if(dd < 10){
      dd = '0' + dd
  }

  if(mm < 10 ){
      mm = '0' + mm
  } 

  if(MM < 10 ){
    MM = '0' + MM
  } 
  
  today = days[day] + ', ' + dd + '/' + mm + '/' + yyyy + ` ${HH}:${MM}`

  return today
}